<template>

    <b-container>
        <b-row>
            <b-col class="calendardate">
                <div class="field mt-3">
                    <Datepicker :showlabel="false" v-model="FilterObj.selectedDate" name="SelectDate" id="SelectDate"
                        label="" @date-select="DateFilterOnChange" @clear-click="DateFilterOnChange" />
                </div>

                <div class=" datetab">
                    <button :class="{ activedate: selectedDate === 'yesterday' }"
                        @click="clickselectdate('yesterday')">Yesterday ({{ yesterday }})</button>
                    <button :class="{ activedate: selectedDate === 'today' }" @click="clickselectdate('today')">Today
                        ({{ today }})</button>
                    <button :class="{ activedate: selectedDate === 'tommorrow' }"
                        @click="clickselectdate('tommorrow')">Tommorrow ({{ tomorrow }})</button>
                </div>
                <div v-if="FilterObj.selectedDate">
                    <div @click="cleardatevalue" class="cleardate">Clear</div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="iqtabs">
                <b-tabs pills>
                    <b-tab title="Patient List" active>
                        <PendingTableView :FilterObj="FilterObj" />
                    </b-tab>
                    <b-tab title="Allocate">
                        <allocateTableView :FilterObj="FilterObj" />
                    </b-tab>
                    <b-tab title="Issued">
                        <issuedTableView :FilterObj="FilterObj" />
                    </b-tab>
                    <b-tab title="Consumption">
                        <consumptionTableView :FilterObj="FilterObj" />
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </b-container>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import moment from "moment";

import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import PendingTableView from "./PendingTableView.vue";
import consumptionTableView from "../../../../../modules/Inventory/pages/Transaction/PatientIssue/consumptionTableView.vue"
import issuedTableView from '../../../../../modules/Inventory/pages/Transaction/PatientIssue/issuedTableView.vue'
import allocateTableView from '../../../../../modules/Inventory/pages/Transaction/PatientIssue/allocateTableView.vue'

export default defineComponent({
    components: {
        Datepicker,
        PendingTableView,
        consumptionTableView,
        issuedTableView,
        allocateTableView
    },
    setup() {
        const FilterObj = ref({
            selectedDate: ref(),
            Date: "",
        });

        const yesterday = moment().subtract(1, "day").format("DD-MM-YYYY");
        const today = moment().format("DD-MM-YYYY");
        const tomorrow = moment().add(1, "day").format("DD-MM-YYYY");

        const statusColumns = {
            pending: [
                { label: "Surgery name", key: "surgeryName" },
                { label: "Lens Diopter", key: "lensDiopter" },
            ],
            allocate: [
                { label: "Allocated On", key: "allocatedOn" },
                { label: "Ward", key: "ward" },
            ],
            issued: [
                { label: "Issued On", key: "issuedOn" },
                { label: "Issued By", key: "issuedBy" },
            ],
            consumption: [
                { label: "Consumed On", key: "consumedOn" },
                { label: "Consumed By", key: "consumedBy" },
            ],
        };

        const selectedDate = ref('today');

        const tableData = ref([]); // Replace with actual data

        function clickselectdate(status) {
            FilterObj.value.selectedDate = ""
            selectedDate.value = status;
            if (selectedDate.value == "yesterday") {
                FilterObj.value.Date = moment(yesterday, "DD-MM-YYYY").format("YYYY-MM-DD");

            }
            else if (selectedDate.value == "today") {
                FilterObj.value.Date = moment(today, "DD-MM-YYYY").format("YYYY-MM-DD");

            }
            else if (selectedDate.value == "tommorrow") {
                FilterObj.value.Date = moment(tomorrow, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
        };

        function cleardatevalue() {
            debugger;
            FilterObj.value.selectedDate = ""
            selectedDate.value = "today"
            FilterObj.value.Date = moment(today, "DD-MM-YYYY").format("YYYY-MM-DD");
        };

        const DateFilterOnChange = () => {
            debugger;
            selectedDate.value = "";
            FilterObj.value.Date = moment(FilterObj.value.selectedDate).format("YYYY-MM-DD");
        }

        return {
            FilterObj,
            selectedDate,
            clickselectdate,
            yesterday,
            today,
            tomorrow,
            cleardatevalue,
            DateFilterOnChange
        }
    }
})
</script>
<style lang="scss">
.calendardate {
    display: flex;
    gap: 15px;
    align-items: center;
    padding-top: 15px;
}


.datetab button {
    all: unset;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    color: #999999;
    padding: 10px 15px;
    margin: 10px 5px;
}

.datetab button {
    margin: 10px 0px;
    border-radius: 0;
}


.datetab button.activedate {
    background-color: #007bff;
    color: #ffffff;
    border: none;
}

.cleardate {
    border-radius: 7px;
    background-color: #ff4a4a;
    color: #FFFFFF;
    padding: 10px 15px;
}

.iqtabs {
    position: relative;

    .nav-pills .nav-link {
        border: 1px solid #e1e1e1 !important;
        border-radius: 20px;
        margin-inline: 10px;
    }

    .nav-pills {
        position: absolute !important;
        z-index: 10;
        top: 5%;
        left: 3%;
    }
}
</style>